import React from "react";
import StandardButton from "../UI/buttons/StandardButton";
import labels from "../../utils/labels";

export const NeedHelpButton: React.FC = () => {
  const handleClick = () => {
    const link = document.createElement("a");
    link.href =
      "https://scrubjay.atlassian.net/wiki/external/YTVkMThkZGVlOGIyNDFkOGFjNDg4ODczZDViNzY2ZWY";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.download = "pondoo-guide.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <StandardButton
      variant="TERTIARY"
      ariaLabel={labels.needHelp}
      onClick={handleClick}
    >
      {labels.needHelp}
    </StandardButton>
  );
};
